import React, {useEffect, useState} from "react";
import {deleteResource, getByIdResource} from "../../service/http-service";
import './ProfileSegmentStyle.css'
import DeleteModal from "../../ui/DeleteModal";
import Edit from '../../../assets/img/profile-images/Uredi-icon.png';
import Delete from '../../../assets/img/profile-images/Izbrisi-icon.png';
import Plus from '../../../assets/img/profile-images/Otvori-icon.png';
import Minus from '../../../assets/img/profile-images/Zatvori-icon.png';
import {DateLabelFormatter} from "../../ui/DateLabelFormatter";
import {GenericEditModalForm} from "./GenericEditModalForm";


export const ProfileAdditionalQualificationSegment = ({candidate, isPreview}) => {

    const [resultListEmpty, setResultListEmpty] = useState(true);
    const [showOneElement, setShowOneElement] = useState(true);
    const [firstElementFromList, setFirstElementFromList] = useState({})
    const [candidateExistingList, setCandidateExistingList] = useState([]);
    const [updateAdditionalQualifications, setUpdateAdditionalQualifications] = useState(false)

    const [entity, setEntity] = useState({candidate: candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)

    const getCandidateExistingList = () => {
        getByIdResource('candidate_additional_qualifications/get_by_candidate', candidate.id).then(data => {
            setCandidateExistingList(data.data);
            setFirstElementFromList(data.data[0])
            if(data.data && data.data.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(data.data && data.data.length === 1){
                setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
            }
        })
    }
    const confirmDelete = (data, url, refreshEntity, setRefreshEntity) => {
        deleteResource(url, data).then(() =>{
            setRefreshEntity(!refreshEntity);
        }).catch((error) => {
            console.log('error')
        })
    }

    useEffect(()=> {
        getCandidateExistingList();
    },[])

    useEffect(() => {
        getByIdResource('candidate_additional_qualifications/get_by_candidate', candidate.id).then(data => {
            setCandidateExistingList(data.data);
        })
    }, [updateEntity, updateAdditionalQualifications])



    return(
        <div className='profile_segment_main_container'>
            {firstElementFromList && (candidateExistingList && candidateExistingList.length > 0) && showOneElement ?
                <div className='profile_segment_separate_info d-flex justify-content-between'>
                   <div>
                       {firstElementFromList.additionalQualificationType &&  <h5>Тип на квалификација: {firstElementFromList.additionalQualificationType &&
                           firstElementFromList.additionalQualificationType.name}</h5>}
                       {firstElementFromList.title && <p>Име:<span> {firstElementFromList.title}</span></p>}
                       {firstElementFromList.institution && <p>Институција: <span>{firstElementFromList.institution}</span></p>}
                       {(firstElementFromList.startDate || firstElementFromList.endDate) &&
                           <p>Период : <span><DateLabelFormatter dateString={firstElementFromList.startDate}/> - <DateLabelFormatter
                               dateString={firstElementFromList.endDate}/></span></p>}
                       {firstElementFromList.country && <p>Држава: <span>
                        {firstElementFromList.country && firstElementFromList.country.name}
                    </span></p>}
                   </div>
                   <div className="icons-div justify-self-end">
                       {!isPreview &&  <div className="edit_delete_icons">
                           <img src={Edit} alt="edit" onClick={() => {
                               setShowOneElement(false)
                               setEntity(firstElementFromList)
                               setAddEntity(true)}
                           }/>
                           <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                               confirmDelete(firstElementFromList, 'candidate_additional_qualifications', updateAdditionalQualifications, setUpdateAdditionalQualifications)}/>
                       </div>}
                   </div>

                </div> :
                candidateExistingList.map(entity =><>
                    <div className='profile_segment_separate_info d-flex justify-content-between' key={entity.id}>
                       <div>
                           {entity.additionalQualificationType &&  <h5>Тип на квалификација: {entity.additionalQualificationType &&
                               entity.additionalQualificationType.name}</h5>}
                           {entity.title && <p>Име:<span> {entity.title}</span></p>}
                           {entity.institution && <p>Институција: <span>{entity.institution}</span></p>}
                           {(entity.startDate || entity.endDate) &&
                               <p>Период : <span><DateLabelFormatter dateString={entity.startDate}/> - <DateLabelFormatter
                                   dateString={entity.endDate}/></span></p>}
                           {entity.country && <p>Држава: <span>
                        {entity.country && entity.country.name}
                    </span></p>}
                       </div>
                        <div className="icons-div justify-self-end">
                            {!isPreview && <div className="edit_delete_icons">
                                <img src={Edit} alt="edit" onClick={() => {
                                    setShowOneElement(false)
                                    setEntity(entity)
                                    setAddEntity(true)}
                                }/>
                                <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                                    confirmDelete(entity, 'candidate_additional_qualifications', updateAdditionalQualifications, setUpdateAdditionalQualifications)}/>
                            </div>}
                        </div>
                    </div>
                <hr/>
                    </>
                )}

            {!isPreview && !addEntity && (!showOneElement || resultListEmpty ) && (<div className="profile_add_button mt-3"
                                                                                        onClick={() =>
                                                                                        {setEntity({...entity, candidate: candidate})
                                                                                            setAddEntity(true)}}
            >Додади едукација</div>)}
            {addEntity === true && (<div className="open-form">  <GenericEditModalForm
                type="ADDITIONAL_QUALIFICATION"
                title= {!entity.id ? "Додади едукација" : "Уреди едукација"}
                entity={entity} setEntity={setEntity}
                addEntity={addEntity} setAddEntity={setAddEntity}
                updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}/></div>)}

            {(!isPreview && !resultListEmpty) &&
                    <div className='profile_plus_container'><hr/>
                        {showOneElement ?  <img src={Plus} alt='plus' onClick={()=> setShowOneElement(false)}/> :
                            <img src={Minus} alt='plus' onClick={()=> {
                                setShowOneElement(true)
                            setAddEntity(false)}
                            }/>}
                    </div>
            }
        </div>
    )
}